/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../record-editor/json-editor-wrapper/json-editor-wrapper.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/holdingpen-editor/holdingpen-save-button/holdingpen-save-button.component';
import * as i3 from '@angular/router';
import * as i4 from '../../../../app/core/services/holdingpen-api.service';
import * as i5 from '../../../../app/core/services/record-cleanup.service';
import * as i6 from '../../../../app/core/services/dom-utils.service';
import * as i7 from '../../../../app/core/services/global-app-state.service';
import * as i8 from 'ngx-toastr';
const styles_HoldingpenSaveButtonComponent:any[] = [i0.styles];
export const RenderType_HoldingpenSaveButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HoldingpenSaveButtonComponent,data:{}});
export function View_HoldingpenSaveButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'button',[['class',
      'btn btn-default navbar-btn btn-success'],['type','button']],[[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.HoldingpenSaveButtonComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onClickSave()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),0,'i',[['aria-hidden','true'],['class',
          'fa fa-floppy-o']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(3,0,(null as any),(null as any),1,'span',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['Save'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(null as any),(_ck,_v) => {
    var _co:i2.HoldingpenSaveButtonComponent = _v.component;
    const currVal_0:any = _co.saveButtonDisabledAttribute;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_HoldingpenSaveButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-holdingpen-save-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_HoldingpenSaveButtonComponent_0,
      RenderType_HoldingpenSaveButtonComponent)),i1.ɵdid(1,245760,(null as any),0,
      i2.HoldingpenSaveButtonComponent,[i3.Router,i1.ChangeDetectorRef,i4.HoldingpenApiService,
          i5.RecordCleanupService,i6.DomUtilsService,i7.GlobalAppStateService,i8.ToastrService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HoldingpenSaveButtonComponentNgFactory:i1.ComponentFactory<i2.HoldingpenSaveButtonComponent> = i1.ɵccf('re-holdingpen-save-button',
    i2.HoldingpenSaveButtonComponent,View_HoldingpenSaveButtonComponent_Host_0,{},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL2hvbGRpbmdwZW4tZWRpdG9yL2hvbGRpbmdwZW4tc2F2ZS1idXR0b24vaG9sZGluZ3Blbi1zYXZlLWJ1dHRvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvaW5zcGlyZWhlcC9yZWNvcmQtZWRpdG9yL3NyYy9hcHAvaG9sZGluZ3Blbi1lZGl0b3IvaG9sZGluZ3Blbi1zYXZlLWJ1dHRvbi9ob2xkaW5ncGVuLXNhdmUtYnV0dG9uLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL2hvbGRpbmdwZW4tZWRpdG9yL2hvbGRpbmdwZW4tc2F2ZS1idXR0b24vaG9sZGluZ3Blbi1zYXZlLWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL2hvbGRpbmdwZW4tZWRpdG9yL2hvbGRpbmdwZW4tc2F2ZS1idXR0b24vaG9sZGluZ3Blbi1zYXZlLWJ1dHRvbi5jb21wb25lbnQudHMuSG9sZGluZ3BlblNhdmVCdXR0b25Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YnV0dG9uIHR5cGU9XCJidXR0b25cIiBjbGFzcz1cImJ0biBidG4tZGVmYXVsdCBuYXZiYXItYnRuIGJ0bi1zdWNjZXNzXCIgW2Rpc2FibGVkXT1cInNhdmVCdXR0b25EaXNhYmxlZEF0dHJpYnV0ZVwiIChjbGljayk9XCJvbkNsaWNrU2F2ZSgpXCI+XG4gIDxpIGNsYXNzPVwiZmEgZmEtZmxvcHB5LW9cIiBhcmlhLWhpZGRlbj1cInRydWVcIj48L2k+PHNwYW4+U2F2ZTwvc3Bhbj5cbjwvYnV0dG9uPiIsIjxyZS1ob2xkaW5ncGVuLXNhdmUtYnV0dG9uPjwvcmUtaG9sZGluZ3Blbi1zYXZlLWJ1dHRvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUE4RztNQUFBO01BQUE7SUFBQTtJQUE5RztFQUFBLGdDQUFzSSw0Q0FDcEk7YUFBQTtVQUFBO1VBQUEsZ0JBQWlEO01BQUE7TUFBTSw0Q0FBVztVQUFBOztJQURDO0lBQXJFLFdBQXFFLFNBQXJFOzs7O29CQ0FBO01BQUE7OENBQUEsVUFBQTt1Q0FBQTs4RkFBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/holdingpen-editor/holdingpen-save-button/holdingpen-save-button.component.ngfactory.ts